import * as React from 'react';
import { Omit } from '../../types/global-types';

export interface InjectedGTMLoggersProps {
  reportGTM(type: any): void;
}

export enum GTMReporters {
  'PackagePicker' = 'PP',
  'CycleSelector' = 'CS',
  'PurchaseSuccess' = 'PS',
  'OrderPage' = 'OP',
}

export const withGtmLogger = <P extends InjectedGTMLoggersProps>(
  Component: React.ComponentType<P>,
): React.ComponentClass<Omit<P, keyof InjectedGTMLoggersProps>> =>
  (class Wrapped extends React.Component<
    Omit<P, keyof InjectedGTMLoggersProps>
  > {
    reportPP = () =>
      window.dataLayer.push({ event: 'Purchase Premium Package Picker' });
    reportCycle = () =>
      window.dataLayer.push({ event: 'Purchase Premium Cycle Selection' });
    reportOrderPage = () =>
      window.dataLayer.push({ event: 'Purchase Premium Plan View Order Page' });
    reportSuccess = () =>
      window.dataLayer.push({ event: 'Purchase Premium Plan Success' });
    reporters = {
      [GTMReporters.PackagePicker]: this.reportPP,
      [GTMReporters.CycleSelector]: this.reportCycle,
      [GTMReporters.PurchaseSuccess]: this.reportSuccess,
      [GTMReporters.OrderPage]: this.reportOrderPage,
    };
    reportGTM = (type) => {
      if (window.dataLayer) {
        this.reporters[type]();
      }
    };

    render() {
      return <Component {...(this.props as P)} reportGTM={this.reportGTM} />;
    }
  });
